module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/array-buffer-native.js
// module id = 167
// module chunks = 48